import { gql } from '@apollo/client';

export const GET_ACTIVE_FARM_SETTING = gql`
    query GetActiveFarmSetting {
        getActiveFarmSetting {
            id
            userId
            settingsId
            farmId
            saved_settings
        }
    }
`;

export const SAVE_ACTIVE_FARM_SETTING = gql`
    mutation SaveActiveFarmSetting($farmId: Int!) {
        saveActiveFarmSetting(farmId: $farmId) {
            id
            userId
            settingsId
            farmId
            saved_settings
        }
    }
`;
